import { useEffect } from 'react';

const withSourceColors = (Component) => (properties) => {
    const source = properties?.source;

    useEffect(() => {
        if (source) {
            document.documentElement.style.setProperty('--color-primary', source.primary_color);
            document.documentElement.style.setProperty('--color-primary-contrast', source.primary_text_color);
            document.documentElement.style.setProperty('--color-secondary', source.secondary_color);
            document.documentElement.style.setProperty('--color-secondary-contrast', source.secondary_text_color);
        }
    }, [source]);

    return <Component {...properties} />;
};

export default withSourceColors;
